import React, { useState } from "react";
import { RpaAccountDataArray, RpaAccount, Command } from "../../../../../../types/types";
import styles from "../SuggestCommon.module.scss";
import { getImageUrl } from "../../../../../../commons/assets_path";
import { createRpaAccount } from "../../../../../../api/api";
import { useTranslation } from "react-i18next";

type Props = {
  rpaAccountDataArray: RpaAccountDataArray;
  setRpaAccount: React.Dispatch<React.SetStateAction<RpaAccount | undefined>>;
  setSuggestPopup: React.Dispatch<React.SetStateAction<{ isVisible: boolean }>>;
  command?: Command;
  clientCode: string;
  client_id: number;
  memberId: number;
  setRpaAccounts: React.Dispatch<React.SetStateAction<RpaAccountDataArray>>;
};

const SuggestId = ({
  rpaAccountDataArray,
  setRpaAccount,
  setSuggestPopup,
  command,
  clientCode,
  client_id,
  memberId,
  setRpaAccounts,
}: Props) => {
  const { t } = useTranslation();
  const [rpaAccounts, setMyApps] = useState<RpaAccountDataArray>(rpaAccountDataArray);
  const [isAddAccountModal, setIsAddAccountModal] = useState(false);
  const [accountForm, setAccountForm] = useState({ serviceName: "", accountId: "", password: "" });
  const [errors, setErrors] = useState({ service_name: [], account_id: [], password: [] });

  const closePopup = (e: React.MouseEvent<HTMLElement>) => {
    setSuggestPopup({ isVisible: false });
    e.stopPropagation();
  };

  const selectAccount = (rpaAccountData: RpaAccount) => {
    setRpaAccount(rpaAccountData);
    setSuggestPopup({ isVisible: false });
  };

  const search = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchWord = e.target.value;
    const result = rpaAccountDataArray.filter((rpaAccountData) => {
      return rpaAccountData.service_name.includes(searchWord);
    });
    setMyApps(result);
  };

  const addAccount = () => {
    setIsAddAccountModal(true);
  };

  const createAccount = async () => {
    const response = await createRpaAccount(
      clientCode,
      client_id,
      memberId,
      accountForm.serviceName,
      accountForm.accountId,
      accountForm.password,
    );
    if (response.status === 200) {
      setRpaAccounts(response.data.rpa_accounts);
      setRpaAccount(response.data.rpa_accounts[response.data.rpa_accounts.length - 1]);
      setIsAddAccountModal(false);
      setAccountForm({ serviceName: "", accountId: "", password: "" });
    } else {
      setErrors(response.data.errors);
    }
  };

  const prevClick = () => {
    setIsAddAccountModal(false);
    setAccountForm({ serviceName: "", accountId: "", password: "" });
    setErrors({ service_name: [], account_id: [], password: [] });
  };

  return (
    <div>
      {isAddAccountModal ? (
        <div style={{ margin: "-12px" }}>
          <div className={styles.createAccountHeader}>
            <img src={getImageUrl("images/icons/prev.svg")} className={styles.prevImg} onClick={prevClick} />
            <div className={styles.title}>{t("SuggestId.ブラウザ操作アカウントの追加")}</div>
            <img
              src={getImageUrl("images/icons/close.svg")}
              className={styles.closeHeaderImg}
              onClick={(e) => closePopup(e)}
            />
          </div>
          <div className={styles.createAccountBody}>
            <div className={styles.accountTitleField}>
              <div className={styles.accountLable}>{t("SuggestId.サービス名")}</div>
              <input
                className={`${styles.accountInput} ${errors.service_name?.length > 0 && styles.errorInput} `}
                value={accountForm.serviceName}
                onChange={(e) => setAccountForm({ ...accountForm, serviceName: e.target.value })}
              />
              {errors.service_name?.length > 0 && <div className={styles.errorMessage}>{errors.service_name[0]}</div>}
            </div>
            <div className={styles.accountTitleField}>
              <div className={styles.accountLable}>{t("SuggestId.ID")}</div>
              <input
                className={`${styles.accountInput} ${errors.account_id?.length > 0 && styles.errorInput} `}
                value={accountForm.accountId}
                onChange={(e) => setAccountForm({ ...accountForm, accountId: e.target.value })}
              />
              {errors.account_id?.length > 0 && <div className={styles.errorMessage}>{errors.account_id[0]}</div>}
            </div>
            <div className={styles.accountTitleField}>
              <div className={styles.accountLable}>{t("SuggestId.パスワード")}</div>
              <input
                type="password"
                className={`${styles.accountInput} ${errors.password?.length > 0 && styles.errorInput} `}
                value={accountForm.password}
                onChange={(e) => setAccountForm({ ...accountForm, password: e.target.value })}
              />
              {errors.password?.length > 0 && <div className={styles.errorMessage}>{errors.password[0]}</div>}
            </div>
            <div className={styles.buttonField}>
              <button className={styles.actionAddButton} onClick={createAccount}>
                {t("SuggestId.追加")}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.header} data-testid="suggest-id">
            <div className={styles.searchForm}>
              <img src={getImageUrl("images/icons/searchGray.svg")} />
              <input
                className={styles.searchInput}
                type="search"
                placeholder={t("SuggestId.検索")}
                onChange={(e) => search(e)}
              />
            </div>
            <img
              src={getImageUrl("images/icons/close.svg")}
              className={styles.closeImg}
              onClick={(e) => closePopup(e)}
            />
          </div>
          <div className={styles.scrollableContainer}>
            <div className={styles.scrollableBody}>
              {rpaAccounts.length > 0 &&
                rpaAccounts.map((rpaAccountData, index) => {
                  return (
                    <div
                      className={styles.suggestItem}
                      key={rpaAccountData.id}
                      onClick={() => selectAccount(rpaAccountData)}
                      data-testid={`suggest-item-${index}`}
                    >
                      <div className={styles.serviceName}>{rpaAccountData.service_name}</div>
                      {command !== "fill_my_password" && (
                        <div className={styles.accountId}>{rpaAccountData.account_id}</div>
                      )}
                    </div>
                  );
                })}
            </div>
            <div className={styles.addAccountWrapper}>
              <div className={styles.addAccountItem} onClick={addAccount}>
                <img src={getImageUrl("images/icons/addPrimary.svg")} />
                <div className={styles.addText}>{t("SuggestId.アカウントを追加")}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SuggestId;
